<template>
  <div id="footer">
    <div class="content">
      <div class="f_l">
        <div class="image">
          <img src="../../assets/images/ytHome/footer_logo.png" />
        </div>
        <div class="list">
          西安市雁塔区教育局版权所有&nbsp;，陕ICP备2023001730号-1
          <!-- <div class="item"></div>
          <div class="item">
            Copyright 2017，All Rights Reserved  湘ICP备12012858号-8
          </div> -->
          <!-- <div class="item">
            <i class="tel-icon"></i>联系电话 ：15090806090
          </div>
          <div class="item">
            <i class="address-icon"></i
            >通讯地址：小寨东路168号雁塔区机关北院1号楼2层
          </div> -->
        </div>
      </div>
      <div class="scan_code">
        <div class="text">官方微信</div>
        <img src="../../assets/images/ytHome/code.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
#footer {
  position: relative;
  width: 100%;
  height: 182px;
  background-color: #740d09;
  .content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .f_l {
      flex: 1;
      .image {
        margin-top: 53px;
        color: #ffffff;
        font-size: 22px;
        font-weight: bold;
        line-height: 31px;
        margin-bottom: 13px;
        text-align: center;
        img {
          height: 45px;
          width: auto;
        }
      }
      .list {
        display: flex;
        justify-content: center;
        color: #e0e6f0;
        .item {
          font-size: 14px;
          color: #e0e6f0;
          line-height: 20px;
          i {
            display: inline-block;
            width: 20px;
            height: 20px;
            vertical-align: middle;
            margin-right: 3px;
            background-size: 100%;
          }
          .tel-icon {
            background: url("../../assets/images/ytHome/tel.png") no-repeat
              center;
          }
          .address-icon {
            background: url("../../assets/images/ytHome/address.png") no-repeat
              center;
          }
        }
      }
    }
    .scan_code {
      margin-top: 54px;
      width: 72px;
      height: 86px;
      margin-left: 20px;
      background-color: #ffffff;
      padding-top: 3px;
      border-radius: 3px;
      .text {
        font-size: 12px;
        text-align: center;
        line-height: 20px;
      }
      img {
        width: 54px;
        height: 54px;
        margin-left: 9px;
      }
    }
  }
}
</style>
